import apiClient from './apiClient';
import { User, UserRole } from '../types/auth.types';

export interface LoginCredentials {
  username: string;
  password: string;
}

export const authService = {
  login: (credentials: LoginCredentials) => 
    apiClient.post('/authenticate', credentials, {headers : { 'Content-Type': 'application/json' }}),

  // Nouvelle méthode pour récupérer les informations de l'utilisateur connecté
  getAccount: () => 
    apiClient.get<User>('/account'),

  getCurrentUser: () => 
    apiClient.get<User>('/account'),

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  hasPermission: (requiredRole: UserRole): boolean => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user.authorities) return false;
    return user.authorities.includes(requiredRole);
  },

  // Méthode utilitaire pour vérifier si l'utilisateur a au moins un des rôles requis
  hasAnyRole: (requiredRoles: UserRole[]): boolean => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user.authorities) return false;
    return requiredRoles.some(role => user.authorities.includes(role));
  },

  //change password
  changePassword: ({currentPassword, newPassword}) =>
    apiClient.post('/account/change-password', {'currentPassword': currentPassword, 'newPassword': newPassword}),

  // Reset password - Init (demande de réinitialisation)
  resetPasswordInit: (email: string) =>
    apiClient.post('/account/reset-password/init',email),

  // Reset password - Finish (finalisation avec nouveau mot de passe)
  resetPasswordFinish: (key: string, newPassword: string) =>
    apiClient.post('/account/reset-password/finish', { key, newPassword }),

  // Admin: Reset password for agency/subscriber
  adminResetPassword: (userId: number, newPassword: string) =>
    apiClient.post(`/admin/users/${userId}/reset-password`, { newPassword })
  
};